import React from 'react'
import { Router, Route, Switch } from 'dva/router'
import { createBrowserHistory } from 'history'
import shansongStudy from './shansongStudy'
import recruit from './recruit'
import equipCertification from './equipCertification'
import seviceScore from './seviceScore'
import main from './main'
import insurance from './insurance'
import freeCard from './freeCard'
import rewardCenter from './rewardCenter'
import customerService from './customerService'
import wallet from './wallet'
import order from './order'
import equipmentAudit from './equipmentAudit'
// import sendOrders from './sendOrders'
import equipmentMall from './equipmentMall'
import activityCenter from './activityCenter'
import messageCenter from './messageCenter'
import trainingSite from './trainingSite'
import recommendAwards from './recommendAwards'
import scanToOrder from './scanToOrder'
import noviceGuide from './noviceGuide'
import shCommitment from './shCommitment'
import myVehicle from './myVehicle'
import suppliersList from './suppliersList'
import waitingVerified from './waitingVerified'
import commitment from './commitment'
import penaltyRecord from './penaltyRecord'
import shansongValue from './shansongValue'
import honourKnight from './honourKnight'
import levelSys from './levelSys'
import gold from './gold'
import widget from './widget'
import widgetMall from './widgetMall'
import eleCarQuestionnaire from './eleCarQuestionnaire'
import longPartner from './longPartner'
import acceleratorCard from './acceleratorCard'
import recommendMessenger from './recommendMessenger'
import recommendUser from './recommendUser'
import commonComponent from './commonComponent'
import courierTask from './courierTask'
import forceSurvey from './forceSurvey'
import accidentTransfer from './accidentTransfer'
// import clothingAudit from './clothingAudit'
import middleJump from './middleJump'
import swapElectricity from './swapElectricity'
import courierProve from './courierProve'
import helmetAudit from './helmetAudit'
const routers = [...main, ...shansongStudy, ...recruit, ...seviceScore, ...equipCertification, ...insurance, ...rewardCenter, ...freeCard, ...wallet, ...order, ...equipmentAudit, ...customerService, ...activityCenter, ...messageCenter, ...noviceGuide, ...trainingSite, ...recommendAwards, ...scanToOrder, ...shCommitment, ...equipmentMall, ...myVehicle, ...suppliersList, ...waitingVerified, ...commitment, ...widgetMall, ...gold, ...widget, ...levelSys, ...shansongValue, ...honourKnight, ...penaltyRecord, ...eleCarQuestionnaire, ...longPartner, ...acceleratorCard, ...recommendMessenger, ...commonComponent, ...recommendUser, ...forceSurvey, ...courierTask, ...accidentTransfer, ...middleJump, ...swapElectricity, ...courierProve, ...helmetAudit]

const Routers = () => {
  return (
    <Router history={createBrowserHistory()}>
      <Switch>
        {routers.map((item, index) => {
          return <Route path={item.path} exact={Boolean(item.exact)} render={props => {
            window.document.title = item.meta && item.meta.title || '闪送'
            return <item.component {...props} ></item.component>
          }} key={index} />
        })}
      </Switch>
    </Router>
  )
}
export default Routers
